import ErrorHandler from "../../utils/ErrorHandler";
import AxiosService from "../axios-service/AxiosService";
const managerBff = process.env.REACT_APP_MANAGER_BFF_URL;
import Storage from "../storage-service/Storage";

export default class TargetService {
    static findTargets = async () => {
        let token = null;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (e) {
            ErrorHandler.handleError(e);
        }
        const config = {
            headers: { Authorization: "Bearer " + token }
        };

        const resp = await AxiosService.httpGet(
            `${managerBff}/v2/targets`,
            config
        );
        return resp.data;
    };

    static getOptions = (targets: any[]) => {
        if (!targets) {
            return [];
        }
        const optionList = targets.map(target => {
            return {
                name: target.name,
                value: target.name,
                disabled: false,
                selected: false
            };
        });
        optionList.unshift({
            name: "SELECIONE UM OPÇÃO",
            value: "no_opt",
            disabled: true,
            selected: true
        });
        return optionList;
    };
}
